import { useEffect, useState } from "react";
import { upsertTag, uuidMapping } from "../helper";

export const useHairColorFilter = (talentFilter, talentFilterTags) => {
  const [values, setValues] = useState([]);

  // hydrate
  useEffect(() => {
    const attr = talentFilter?.person_attributes?.find(
      attribute => attribute && attribute.person_attribute_uuid === uuidMapping.hairColor
    );

    if (attr) setValues(attr.list || []);
  }, []);

  useEffect(() => {
    const exists = talentFilter?.person_attributes?.some(
      attribute => attribute && attribute.person_attribute_uuid === uuidMapping.hairColor
    );

    if (!exists) {
      clearHairColor();
    }
  }, [talentFilter]);

  const clearHairColor = () => {
    setValues([]);
  };


  const isDisabled = !values.length;

  const buildHairColorFilter = () => {
    if (isDisabled) return null;

    const hairColorAttribute = {
      person_attribute_uuid: uuidMapping.hairColor,
      contains: false,
      start_value: null,
      end_value: null,
      has_all_in_list: false,
      list: values,
    };

    const tags = upsertTag(
      talentFilterTags,
      uuidMapping.hairColor,
      values
    );

    return { attribute: hairColorAttribute, tags };
  };

  return {
    values,
    setValues,
    isDisabled,
    buildHairColorFilter,
    clearHairColor
  };
};
